export default {
  editButtonLabel: 'EDIT',
  headerActions: 'ACTIONS',
  headerBroadcast: 'BULK SEND',
  headerUser: 'USER',
  noUsersMessage: 'No users have been granted permission to access this inbox.',
  title: 'Inbox User List'
};
